import sentry from '../../../sentry';
import {
  useMemo,
  useCallback,
  useRef,
  useState,
  useContext,
  useEffect,
} from 'react';
import WebhooksTable from './WebhooksTable';
import CustomToast from '../../../common/CustomToast';
import { useToast } from '@chakra-ui/react';
import { getErrors } from '../../../utils/ajax';
import { HttpContext } from '../../../context/HttpContext';
import { MeContext } from '../../../context/MeContext';

const WebhooksTableWrapper = () => {
  const toast = useToast();
  const { authAxios } = useContext(HttpContext);
  const {
    state: { filterEntity },
  } = useContext(MeContext);

  const fetchIdRef = useRef(0);
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const columns = useMemo(
    () => [
      {
        Header: 'Enabled',
        accessor: 'enabled',
        style: { width: '50px', textAlign: 'center' },
      },
      {
        Header: 'Target URL',
        accessor: 'url',
        style: { minWidth: '250px', wordBreak: 'break-word' },
      },
      {
        Header: 'Scope',
        accessor: 'scope',
        style: { width: '150px', minWidth: '150px' },
      },
      {
        Header: 'Events',
        accessor: 'events',
        style: { minWidth: '200px', wordBreak: 'break-word' },
      },
      {
        Header: '',
        accessor: 'actions',
        style: { width: '60px' },
      },
    ],
    []
  );

  const fetchData = useCallback(
    async ({ pageIndex, pageSize }) => {
      const fetchId = ++fetchIdRef.current;
      setLoading(true);

      try {
        const baseUrl = filterEntity
          ? `/api/v1/webhook-subscriptions?entityId=${filterEntity.uuid}&per_page=${pageSize}&page=${
              pageIndex + 1
            }`
          : `/api/v1/webhook-subscriptions?per_page=${pageSize}&page=${
              pageIndex + 1
            }`;

        const response = await authAxios.get(baseUrl);
        console.log(response);

        if (fetchId !== fetchIdRef.current) return;

        const subs = response.data?.data || [];
        const total = response.data?.meta?.totalCount ?? 0;
        const pageCount =
          response.data?.meta?.totalPages || Math.ceil(total / pageSize);

        setItems(subs);
        setTotal(total);
        setPageCount(pageCount);
      } catch (error) {
        const errors = getErrors(error);
        errors.forEach((err) => {
          toast({
            render: (props) => (
              <CustomToast
                status="error"
                title={err || 'Something went wrong'}
                description={!err && 'Please try again later'}
                onClose={props.onClose}
              />
            ),
          });
        });
        setItems([]);
        setTotal(0);
        setPageCount(0);
      } finally {
        setLoading(false);
      }
    },
    [authAxios, filterEntity, toast]
  );

  const normalise = (rows = []) =>
    rows.map((sub) => {
      const a = sub.attributes;
      return {
        id: sub.id,
        url: a.url,
        enabled: a.enabled,
        scopeType: a.scopeType,
        scopeName: a.scopeName,
        events: a.subscribedEvents || [],
        secretKey: a.secretKey,
      };
    });

  const tableData = useMemo(() => normalise(items), [items]);

  return (
    <WebhooksTable
      columns={columns}
      data={tableData}
      fetchData={fetchData}
      isLoading={loading}
      pageCount={pageCount}
      total={total}
      filterEntity={filterEntity}
    />
  );
};

export default WebhooksTableWrapper;
